/**
 *
 * v.4.0  20/09/25  Input NIF/NIE/CIF moderno y optimizado
 *
 **/

import React from "react";
import PropTypes from "prop-types";

const NIF_LETRAS = "TRWAGMYFPDXBNJZSQVHLCKE";
const CIF_LETRAS = "JABCDEFGHI";

class InputIdFiscal extends React.Component {
    constructor(props) {
        super(props);
        const valorInicial = props.valor?.toString().toUpperCase() || "";
        this.state = {
            valor: valorInicial,
            interactuado: false,
            valido: this.validarCodigo(valorInicial)
        };
    }

    // Función para calcular letra/dígito de control
    calcularControl = (codigo) => {
        if (!codigo) return "";

        // NIF simple
        if (/^\d{8}$/.test(codigo)) return NIF_LETRAS[parseInt(codigo, 10) % 23];

        // NIE
        if (/^[XYZ]\d{7}$/.test(codigo)) {
            const map = { X: "0", Y: "1", Z: "2" };
            const num = codigo.replace(/^[XYZ]/, (l) => map[l]);
            return NIF_LETRAS[parseInt(num, 10) % 23];
        }

        // CIF
        if (/^[ABCDEFGHJNPQRSUVW]\d{7}$/.test(codigo)) {
            const cuerpo = codigo.slice(1);
            let sumaPar = 0, sumaImpar = 0;
            for (let i = 0; i < cuerpo.length; i++) {
                const dig = parseInt(cuerpo[i], 10);
                if (i % 2 === 0) sumaImpar += Math.floor(dig * 2 / 10) + (dig * 2 % 10);
                else sumaPar += dig;
            }
            const total = sumaPar + sumaImpar;
            const controlNum = (10 - (total % 10)) % 10;
            const letraInicial = codigo[0];
            if ("PQRSNW".includes(letraInicial)) return CIF_LETRAS[controlNum];
            if ("ABEH".includes(letraInicial)) return controlNum.toString();
            return controlNum.toString();
        }

        return "";
    };

    // Validar código completo
    validarCodigo = (codigo) => {
        if (!codigo || codigo.length < 9) return false;

        const base = codigo.slice(0, 8);
        const control = codigo[8];
        return control === this.calcularControl(base);
    };

    handleChange = (event) => {
        let valor = event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 9);

        // Autocompletar letra/dígito si no se está borrando
        const borrando = valor.length < this.state.valor.length;
        if (!borrando && valor.length >= 8) {
            const base = valor.slice(0, 8);
            const control = this.calcularControl(base);
            if (valor.length === 9 && valor[8] !== control) valor = base + control;
            else if (valor.length < 9) valor = base + control;
        }

        const valido = this.validarCodigo(valor);
        const pulse = !valido && valor.length === 9;

        this.setState({ valor, valido, interactuado: true, pulse });

        if (this.props.onChange) this.props.onChange(valor);
    };

    render() {
        const { valor, valido, interactuado, pulse } = this.state;

        // Determinar estilo del input
        let bordeColor = "#ccc";
        let boxShadow = "none";
        let mostrarError = false;
        let animation = "none";

        const intensidad = valor.length === 9 ? 1 : valor.length > 0 ? 0.5 : 0;

        if (interactuado) {
            bordeColor = valido ? "green" : "red";
            boxShadow = valido
                ? `0 0 ${8 * intensidad}px rgba(0,128,0,${0.6 * intensidad})`
                : `0 0 ${8 * intensidad}px rgba(255,0,0,${0.6 * intensidad})`;
            mostrarError = !valido && intensidad === 1;
            animation = pulse ? "pulse 1s infinite" : "none";
        } else if (!valido && valor.length > 0) {
            bordeColor = "red";
            boxShadow = "0 0 8px rgba(255,0,0,0.6)";
            mostrarError = true;
        }

        return (
            <div style={{ display: "flex", flexDirection: "column" }}>
                <style>
                    {`
                        @keyframes pulse {
                            0% { box-shadow: 0 0 8px rgba(255,0,0,0.6); }
                            50% { box-shadow: 0 0 16px rgba(255,0,0,0.8); }
                            100% { box-shadow: 0 0 8px rgba(255,0,0,0.6); }
                        }
                    `}
                </style>
                <input
                    type="text"
                    value={valor}
                    onChange={this.handleChange}
                    maxLength={9}
                    style={{
                        width: "150px",
                        border: `2px solid ${bordeColor}`,
                        borderRadius: "4px",
                        padding: "4px",
                        fontSize: "14px",
                        boxShadow: boxShadow,
                        transition: "border-color 0.3s ease, box-shadow 0.3s ease",
                        animation: animation
                    }}
                />
                <span
                    style={{
                        color: "red",
                        fontSize: "12px",
                        marginTop: "2px",
                        opacity: mostrarError ? 1 : 0,
                        transition: "opacity 0.3s ease"
                    }}
                >
                    Código inválido
                </span>
            </div>
        );
    }
}

InputIdFiscal.propTypes = {
    className: PropTypes.string,
    valor: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
};

export default InputIdFiscal;
